import React, {Component, PropTypes} from 'react'

class ToolTip extends Component {
  constructor(props) {
    super(props)

    this.affiliate = props.affiliate;
    this.iconClassName = props.iconClassName || 'fa fa-info-circle'
    this.height = props.height 
    this.width = props.width || 300
    this.title = props.title || ''
    this.state = {
      show: false
    }
  }

  toggle = () => {
    this.setState({
      show: !this.state.show
    })
  }

  render() {
    return (<span className={'gnm-tool-tip ' + this.iconClassName} onClick={this.toggle}>
      <div style={{
          display: this.state.show
            ? 'block'
            : 'none'
        }}>
        <div className='clickable-clear-background'></div>

        <div className='tool-tip' style={{
            left: -this.width / 2 + 'px',
            top: '25px'
          }}>

          <div className='title'>{this.title}</div>
          <div className='contents' style={{
              height: this.height ? (this.height + 'px') : 'auto',
              width: this.width + 'px'
            }}>
            {this.props.children}
          </div>
        </div>
      </div>
    </span>)
  }
}

export default ToolTip



// WEBPACK FOOTER //
// ./app/components/custom/ssr/ToolTip.js